import React from "react";
import { Modal } from "react-bootstrap";
import DataTable from "react-data-table-component";

import { useCoachPoolTeamsContext } from "../../../../contexts/CoachPoolTeamsContext";

export default function ModalTeamList() {
  const { dispatch, actions, state } = useCoachPoolTeamsContext();

  const columns = [
    {
      name: "Enterprise",
      selector: "attributes.enterprise",
      sortable: false,
    },
    {
      name: "Team",
      selector: "attributes.title",
      sortable: false,
    },
  ];

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.coachPool != null}
        onHide={() => actions.hideModal(dispatch)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Teams</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="datatable-style">
            <DataTable
              title=""
              columns={columns}
              data={state.teams || []}
              noDataComponent={
                <div className="mt20">
                  {state.teams == null
                    ? "Please, wait ..."
                    : "No matching records found"}
                </div>
              }
              persistTableHead={true}
              pagination
              paginationComponentOptions={{
                selectAllRowsItem: true,
                selectAllRowsItemText: "All",
              }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
